import React from 'react';
import { ZoomIn, ZoomOut, Move, Plus, Settings } from 'lucide-react';
import { Button } from '../../ui/Button';

interface CanvasControlsProps {
  zoom: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onResetView: () => void;
  onAddNode: () => void;
  onShowSettings: () => void;
}

export const CanvasControls: React.FC<CanvasControlsProps> = ({
  zoom,
  onZoomIn,
  onZoomOut,
  onResetView,
  onAddNode,
  onShowSettings
}) => {
  return (
    <>
      {/* Canvas Controls */}
      <div className="absolute top-4 right-4 flex flex-row z-10 shadow-lg rounded-md gap-0" role="toolbar" aria-label="Canvas controls">
        <Button
          id="workflow-zoom-in-btn"
          size="sm"
          variant='secondary'
          onClick={onZoomIn}
          disabled={zoom >= 2}
          className="bg-white shadow-sm py-1 border-0"
          title="Zoom In"
          aria-label="Zoom in on canvas"
        >
          <ZoomIn className="w-4 h-4" aria-hidden="true" />
        </Button>
        
        <Button
          id="workflow-zoom-out-btn"
          size="sm"
          variant='secondary'
          onClick={onZoomOut}
          disabled={zoom <= 0.5}
          className="bg-white shadow-sm py-1 border-0"
          title="Zoom Out"
          aria-label="Zoom out on canvas"
        >
          <ZoomOut className="w-4 h-4" aria-hidden="true" />
        </Button>
        
        <Button
          id="workflow-reset-view-btn"
          size="sm"
          variant='secondary'
          onClick={onResetView}
          className="bg-white shadow-sm py-1 border-0"
          title="Re-center"
          aria-label="Reset canvas view to center"
        >
          <Move className="w-4 h-4" aria-hidden="true" />
        </Button>
        
        <Button
          id="workflow-settings-btn"
          size="sm"
          variant='secondary'
          onClick={onShowSettings}
          className="bg-white shadow-sm py-1 border-0"
          title="Workflow Settings"
          aria-label="Open workflow settings"
        >
          <Settings className="w-4 h-4" aria-hidden="true" />
        </Button>
      </div>

      {/* Floating Add Node Button */}
      <div className="absolute bottom-6 right-6 z-20">
        <Button
          id="workflow-add-node-btn"
          onClick={onAddNode}
          className="rounded-full w-14 h-14 bg-blue-600 hover:bg-blue-700 text-white shadow-xl flex items-center justify-center"
          title="Add Node"
          aria-label="Add new node to workflow"
        >
          <Plus className="w-6 h-6" aria-hidden="true" />
        </Button>
      </div>
    </>
  );
};